export const youtube_color = () => (
  <>
    <path
      d="M22.5403 6.42033C22.2873 5.46764 21.5418 4.71732 20.5953 4.46269C18.8796 4 12 4 12 4C12 4 5.12044 4 3.40474 4.46269C2.45821 4.71736 1.71273 5.46764 1.45971 6.42033C1 8.14715 1 11.75 1 11.75C1 11.75 1 15.3528 1.45971 17.0797C1.71273 18.0324 2.45821 18.7514 3.40474 19.006C5.12044 19.4687 12 19.4687 12 19.4687C12 19.4687 18.8796 19.4687 20.5953 19.006C21.5418 18.7514 22.2873 18.0324 22.5403 17.0797C23 15.3528 23 11.75 23 11.75C23 11.75 23 8.14715 22.5403 6.42033Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#FF0000"
    />
    <path
      d="M9.74999 15.0211V8.47889L15.5 11.7501L9.74999 15.0211Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="white"
    />
  </>
);
